import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { faCircleInfo, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Offcanvas from "react-bootstrap/Offcanvas";
function BrandList({ brands }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="success" onClick={handleShow}>
        <FontAwesomeIcon
          style={{
            cursor: "pointer",
          }}
          className="align-self-center fs-5"
          title="View Brands"
          icon={faCircleInfo}
        />
      </Button>
      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Vendors</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className="list-group list-group-flush">
            {brands &&
              brands.map((brand) => (
                <li
                  className="list-group-item"
                  key={brand._id}
                  style={{ fontSize: "13px" }}
                >
                  {brand.name}
                </li>
              ))}
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default BrandList;
